import React from 'react';
import PropTypes from 'prop-types';
import applySkeleton from '../../../hocs/applySkeleton';

const SubContent = ({ subContent, theme }) => (
    <div className={ theme.subContent }>
        {subContent}
    </div>
);

SubContent.propTypes = {
    subContent: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({}),
    ]),
    theme: PropTypes.shape({}),
};

export default applySkeleton(SubContent);
